import React from "react";
import "./styles.css";
import { Table } from "../Table";
import icons from "../../constants/icons";
import { Tabs } from "../Tabs";

class TransactionPanelTab extends React.Component {
  storeNameInfo = (el) => {
    return (
      <li className="list-group-item">
        <div className="storeInfo">
          {/* <div className="storeInfoContainer">
            <div className="storeIcon">
              <span className={`icon ${process.env.REACT_APP_ICONS_TYPE}`}>
                {icons.store}
              </span>
            </div>
          </div> */}
          <div>
            <h3>{el?.store?.storeName}</h3>
            <p>
              <span>
                Status: <b>{el?.store?.status}</b>
              </span>
            </p>
          </div>
        </div>
        <div>{this.handleCollectionPoints(el.collectionPoints || [])}</div>
        <div>
          {this.handleProcessingStatement(el.processingStatement || {})}
        </div>
      </li>
    );
  };

  handleCollectionPoints = (data) => {
    return (
      <>
        <div className="header">
          <p className="text-bold">Collection Points</p>
        </div>
        <ul className="list-item">
          {data.map((el, i) => {
            return (
              <div className="collectionPointItem" key={i}>
                <div>
                  {/* <div className="storeInfoContainer"> */}
                  {/* <div className="storeIcon">
                      <span
                        className={`icon ${process.env.REACT_APP_ICONS_TYPE}`}
                      >
                        {icons.store}
                      </span>
                    </div> */}
                  {/* </div> */}
                  <h3>{el?.collectionPoint?.name}</h3>
                  <p>
                    Type: <b>{el?.collectionPoint?.collectionType}</b>
                  </p>
                </div>

                {this.handleProcessingStatement(el.processingStatement)}
              </div>
            );
          })}
        </ul>
      </>
    );
  };

  handleProcessingStatement = (data) => {
    return (
      <>
        <div className="header">
          <h3 className="header-item">Processing Statement</h3>
          <p>{data.date}</p>
        </div>
        <ul className="list-group">
          {data.feesReport?.map((el, i) => {
            return <div key={i}>Fees report:{JSON.stringify(el)}</div>;
          })}
        </ul>
        {this.handleTransactionTypeReport(data.transactionTypeReport)}
      </>
    );
  };

  handleTransactionTypeReport = (data) => {
    return data.map((transactionType, i) => {
      const tabsData = transactionType.paymentModeReport?.map((paymentMode) => {
        const headers = [
          { title: "No Of Transactions", key: "noOfTransactions" },
          {
            title: "Transaction Result",
            key: "transactionResult",
            type: "status",
          },
          { title: "Total Amount", key: "totalAmount" },
          { title: "Fees", key: "fees" },
          { title: "Amount", key: "amount" },
          { title: "Amount Confirmed", key: "amountConfirmed" },
        ];

        return {
          title: paymentMode.paymentMode,
          data: (
            <Table
              bordered
              data={paymentMode.transactionResultReport}
              headers={headers}
            />
          ),
        };
      });

      return (
        <div key={i}>
          <div className="header">
            <h3 className="header-item">{transactionType.type}</h3>
          </div>
          <Tabs options={tabsData} />
        </div>
      );
    });
  };

  render() {
    return (
      <div className="history-data-container">
        {this.props.data?.map((el) => {
          return <ul className="list-group">{this.storeNameInfo(el)}</ul>;
        })}
      </div>
    );
  }
}

export default TransactionPanelTab;
